import { render, staticRenderFns } from "./LeadsTable.vue?vue&type=template&id=047408b0&scoped=true&"
import script from "./LeadsTable.vue?vue&type=script&lang=js&"
export * from "./LeadsTable.vue?vue&type=script&lang=js&"
import style0 from "./LeadsTable.vue?vue&type=style&index=0&id=047408b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047408b0",
  null
  
)

export default component.exports